/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.18.0
 */

import styled from 'styled-components';

import { colors } from '../../../../theme';

export const AutoReportIdTableFooterStyled = styled.div`
    position: sticky;
    bottom: 33px;

    display: flex;
    align-items: center;

    background-color: ${colors.backgroundColorWhite};
    padding: 16px;

    > *:not(:last-child) {
        margin-right: 16px;
    }
`;
